var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lgrm-question-widget"},[_c('div',{staticClass:"lgrm-question"},[_vm._t("question",[_vm._v(_vm._s(_vm.updatedQuestion))])],2),_c('div',{staticClass:"lgrm-question-options"},[_vm._t("question-options")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }